import React, { useState, useMemo, useCallback , useEffect} from "react";
import axios from "axios";
import { saveAs } from 'file-saver';
import StepProgress from "../../components/stepper/StepProgress";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useLocation } from "react-router-dom";
import AppNavigation from "../../components/navigation/appNavigation/AppNavigation";
import CanvasLogo from "../../../assets/images/canvasLogo.png";
import LoadingOverlay from "../../components/overlays/LoadingOverlay";
import "../../../assets/styles/Common.css";
import { useFibQuestions } from "../../hooks/QuestionPage/useFibQuestions";
import { useMcqQuestions } from "../../hooks/QuestionPage/useMcqQuestions";
import {
  useShortQuestions,
} from "../../hooks/QuestionPage/useShortQuestions";
import { useTrueOrFalseQuestions } from "../../hooks/QuestionPage/useTrueOrFalseQuestions";
import { useWhQuestions } from "../../hooks/QuestionPage/useWhQuestions";
import { useScenarioQuestions } from "../../hooks/QuestionPage/useScenarioQuestions.js";
import useTotalQuestionIdeas from "../../hooks/QuestionPage/useTotalQuestionIdeas";
import McqQuestionsRenderer from "../../components/questionRenderer/QuestionIdeas/McqQuestionsRenderer";
import FibQuestionsRenderer from "../../components/questionRenderer/QuestionIdeas/FibQuestionsRenderer";
import TrueOrFalseQuestionsRenderer from "../../components/questionRenderer/QuestionIdeas/TrueOrFalseQuestionRenderer";
import WhQuestionsRenderer from "../../components/questionRenderer/WhQuestions/WhQuestionsRenderer";
import InterpretiveQuestionsRenderer from "../../components/questionRenderer/InterpretiveQuestions/InterpretiveQuestionsRenderer";
import {
  commonErrorToastMessage,
  commonSuccessToastMessage,
} from "../../components/toastify/AllToastifyErrors";
import useCanvasDetection from "../../hooks/useCanvasDetection";
import newQuizzeLog from "../../../assets/images/canvasNewQuizzeimg.png";
import wordLogo from "../../../assets/images/wordLogo.png";
import pdfLogo from "../../../assets/images/pdfLogo1.png";
import textLogo from "../../../assets/images/textLogo.png";
import qtiLogo from "../../../assets/images/QuestionPage/qtiLogo4.png";
import QTIVersion2 from "../../../assets/images/QtizipimageorgQTI V2.1.jpg";
import Moodleimage from "../../../assets/images/Moodleimage.jpg";
import { jsPDF } from "jspdf";
import RateYourQuestionsModal from "../../components/modals/RateYourQuestionsModal";
import { logoBase64 } from "../../../assets/images/base64Images/EduvateBase64.js";
import { useDescriptiveQuestions } from "../../hooks/QuestionPage/useDescriptiveQuestions";
import { saveQuestions } from "../../api/saveQuestions";
import { fetchUsersAllQuestions } from "../../api/fetchUsersAllQuestions";
import QuillionzProUpgradeModal from "../../components/modals/QuillionzProUpgradeModal";
import { getDecryptedBatch, setEncrypted } from "../../utils/cryptoUtils.js";

const Question = () => {
// ── Non-sensitive session keys — plain localStorage is fine ──────────────
  const isSampleButtonClicked = localStorage.getItem("isSampleButtonClicked") === "true";
  const ResponseQA             = JSON.parse(localStorage.getItem("QAreqbody"));

  const location                            = useLocation();
  const isCanvas                            = useCanvasDetection();
  const generatedQuestionsFromSubmitContent = location.state?.generatedQuestions;
  const cameFromHistoryPage                 = location.state?.historyPage;
  const totalQuestionsGenerated             = location?.state?.totalQuestionsGenerated;
  const individualTitleFromHistory          = location.state?.title;
  const individualDocIdFromHistory          = location.state?.doc_id;
  const userQuestionsSets                   = location.state?.userAttempts;

  let title = ResponseQA?.title || localStorage.getItem("title");

  const doc_id        = ResponseQA?.doc_id || localStorage.getItem("doc_id");
  const totalQuestions = totalQuestionsGenerated || localStorage.getItem("totalQuestionsGenerated");

  // ── Encrypted localStorage values — live in state ─────────────────────────
  const [email, setEmail]     = useState("");
  const [Version, setVersion] = useState("");

  // ── Step 1: Decrypt all needed values once on mount ──────────────────────
  useEffect(() => {
    const loadSecureData = async () => {
      const {
        email:   decryptedEmail,
        Version: decryptedVersion,
      } = await getDecryptedBatch(["email", "Version"]);

      setEmail(decryptedEmail ?? "");
      setVersion(decryptedVersion ?? "");
    };

    loadSecureData();
  }, []);

  // ── Write back updatedAttempts using encrypted storage ───────────────────
  // Replaces the raw  localStorage.setItem("UserAttempts", ...)  at the top level
  useEffect(() => {
    const updatedAttempts =
      generatedQuestionsFromSubmitContent?.updatedAttempts ?? userQuestionsSets;

    if (updatedAttempts !== undefined && updatedAttempts !== null) {
      setEncrypted("UserAttempts", updatedAttempts);
    }
  }, [generatedQuestionsFromSubmitContent, userQuestionsSets]);

  // ── UI state ──────────────────────────────────────────────────────────────
  const [activeTab, setActiveTab]         = useState("first");
  const [open, setOpen]                   = useState(false);
  const [loading, setLoading]             = useState(false);
  const [isRateYourQuestionModalOpen, setIsRateYourQuestionModalOpen] = useState(false);
  const [isShortAnswerClicked, setIsShortAnswerClicked]               = useState(true);
  const [isInterpretiveQuestionsClicked, setIsInterpretiveQuestionsClicked] = useState(true);
  const [showManageSubscription, setShowManageSubscription]           = useState(false);
  const [isNotesClicked, setIsNotesClicked]                           = useState(true);
  const [isMultipleChoiceClicked, setIsMultipleChoiceClicked]         = useState(true);
  const [isOnlyShortQAClicked, setIsOnlyShortQAClicked]               = useState(true);
  const [isOnlyRecallQAClicked, setIsOnlyRecallQAClicked]             = useState(true);
  const [hideInterpretiveQuestions, setHideInterpretiveQuestions]     = useState(false);
  const [questionsSavedCount, setQuestionsSavedCount]                 = useState(0);
  const [isScrollbarVisible, setScrollbarVisibility]                  = useState(false);
  let [totalQuestionNumber, setTotalQuestionNumber] = useState("");
  const [totalWh, setTotalWh] = useState("");

  const activeStep = 3;

  // ── Question hooks ────────────────────────────────────────────────────────
  let {
    mcqsQuestions,
    handleMcqQuestionsEdit, handleMcqQuestionDelete,
    handleMcqQuestionChange, handleOptionEdit,
    handleOptionChange, handleOptionBlur, editingOptionIndices,
  } = useMcqQuestions(generatedQuestionsFromSubmitContent, setTotalQuestionNumber, totalQuestionNumber);

  const { shortQuestions } = useShortQuestions(generatedQuestionsFromSubmitContent, setTotalQuestionNumber, totalQuestionNumber);

  let {
    fibQuestions,
    handleFibQuestionChange, handleFibAnswerChange,
    handleFibQuestionsEdit, handleFibAnswersEdit, handleFibQuestionDelete,
  } = useFibQuestions(generatedQuestionsFromSubmitContent, setTotalQuestionNumber, totalQuestionNumber);

  let {
    trueFalseQuestions,
    handleTrueOrFalseQuestionsEdit, handleTrueOrFalseQuestionDelete, handleTrueOrFalseQuestionChange,
  } = useTrueOrFalseQuestions(generatedQuestionsFromSubmitContent, setTotalQuestionNumber, totalQuestionNumber);

  const { descriptiveQuestions } = useDescriptiveQuestions(generatedQuestionsFromSubmitContent, setTotalQuestionNumber, totalQuestionNumber);

  let {
    whQuestions,
    handleShortWhQuestionChange, handleShortWhAnswerChange,
    handleShortWhQuestionsEdit, handleShortWhAnswersEdit, handleShortWhQuestionDelete,
  } = useWhQuestions(generatedQuestionsFromSubmitContent, setTotalWh, totalWh);

  let {
    scenarioQuestions,
    handleScenarioQuestionChange, handleScenarioAnswerChange,
    handlescenarioQuestionsEdit, handleScenarioAnswersEdit, handleScenarioQuestionDelete,
  } = useScenarioQuestions(generatedQuestionsFromSubmitContent, setTotalQuestionNumber, totalQuestionNumber);

  useTotalQuestionIdeas(generatedQuestionsFromSubmitContent, setTotalQuestionNumber);

  let [notesContent, setNotesContent] = useState(
    generatedQuestionsFromSubmitContent?.response?.questions?.questionset?.notes ||
    generatedQuestionsFromSubmitContent?.questions?.questionset?.questionset?.notes ||
    generatedQuestionsFromSubmitContent?.notes || ""
  );

  const getUniqueListBy = useCallback((array) => {
    return Array.from(new Set(array.map(JSON.stringify))).map(JSON.parse);
  }, []);

  const mergedObjectiveQuestion = useMemo(() => {
    if (!isMultipleChoiceClicked) return fibQuestions;
    if (!isOnlyRecallQAClicked)   return [...mcqsQuestions, ...trueFalseQuestions];
    return [...mcqsQuestions, ...fibQuestions, ...trueFalseQuestions];
  }, [mcqsQuestions, fibQuestions, trueFalseQuestions, isMultipleChoiceClicked, isOnlyRecallQAClicked]);

  let mergedDescriptiveQuestion = useMemo(() => {
    return getUniqueListBy([...whQuestions, ...descriptiveQuestions], "question");
  }, [whQuestions, descriptiveQuestions]);

  let multipleChoiceQuestions = mcqsQuestions.length + trueFalseQuestions.length;
  if (!isMultipleChoiceClicked) totalQuestionNumber -= multipleChoiceQuestions;
  if (!isOnlyShortQAClicked)    totalQuestionNumber -= shortQuestions.length;
  if (!isOnlyRecallQAClicked)   totalQuestionNumber -= fibQuestions.length;

  useEffect(() => {
    const total = mcqsQuestions.length + fibQuestions.length + trueFalseQuestions.length;
    setTotalQuestionNumber(total);
  }, [mcqsQuestions, fibQuestions, trueFalseQuestions]);

  // ── Write totalQuestionsGenerated back (non-sensitive, plain is fine) ─────
  localStorage.setItem(
    "totalQuestionsGenerated",
    totalQuestionNumber + whQuestions.length + scenarioQuestions.length
  );
  localStorage.setItem("allInterpretiveDeleted", scenarioQuestions.length === 0);

  const tabData = [
    { id: "first",  label: "Objective Questions", total: totalQuestionNumber },
    { id: "second", label: whQuestions.length <= 1 ? "Descriptive Question" : "Descriptive Questions", total: isShortAnswerClicked ? whQuestions.length : 0 },
    { id: "third",  label: scenarioQuestions.length <= 1 ? "Scenario Question" : "Scenario Questions", total: isInterpretiveQuestionsClicked ? scenarioQuestions.length : 0 },
    { id: "fourth", label: "Summary" },
  ];

  const handleTabClick          = (tabName) => { setActiveTab(tabName); setScrollbarVisibility(!isScrollbarVisible); };
  const handleRateYourQuestions = () => setIsRateYourQuestionModalOpen(true);
  const handleRecallButtonClick = () => setHideInterpretiveQuestions(true);

  // ── Save questions — uses email from state ────────────────────────────────
  const handleQuestionsSaveToDB = async () => {
    try {
      setLoading(true);

      const descriptiveQuestion = descriptiveQuestions.filter((d) =>
        whQuestions.find((w) => w.question === d.question)
      );
      const docTitle = ResponseQA?.title || localStorage.getItem("title");
      const totalQues =
        mergedDescriptiveQuestion.length + mcqsQuestions.length +
        trueFalseQuestions.length + fibQuestions.length + scenarioQuestions.length;

      // ✅ email comes from state (decrypted on mount) — no localStorage.getItem needed
      await saveQuestions(
        whQuestions, mcqsQuestions, trueFalseQuestions, fibQuestions,
        descriptiveQuestion, scenarioQuestions, notesContent,
        doc_id, email, totalQues, docTitle
      );

      const userQuestionsHistory = await fetchUsersAllQuestions(email);
      setQuestionsSavedCount((c) => c + 1);
      localStorage.setItem("usersQuestionHistory", JSON.stringify(userQuestionsHistory.data.doc_list));
      commonSuccessToastMessage("Success! Your questions have been saved.");
      setLoading(false);
    } catch (error) {
      console.error("Error while saving the questions:", error);
      commonErrorToastMessage("Oops! Failed to save your questions. Please try again later.");
      setLoading(false);
    }
  };

  // ── Export — Version comes from state ────────────────────────────────────
  const exportQuestions = async (e, type) => {
    setLoading(true);
    const { dataset } = e.target;
    const exportType = dataset.exportType || type;

    // ✅ Version comes from state (decrypted on mount)
    if (isSampleButtonClicked && Version === "Free" && exportType !== "txt") {
      e.preventDefault();
      e.stopPropagation();
      setShowManageSubscription(true);
      setLoading(false);
      return;
    }

    let endpoint = "";
    if (exportType === "qti")              endpoint = "api/lti/export_to_canvas";
    if (exportType === "newQuizzes")       endpoint = "api/lti/export_to_canvas_new_quizze";
    if (exportType === "qtizipv2")         endpoint = "api/lti/export_to_qtiVersion2";
    if (exportType === "doc")              endpoint = `api/export/${exportType}`;
    if (exportType === "pdf")              endpoint = `api/export/${exportType}`;
    if (exportType === "txt")              endpoint = `api/export/${exportType}`;
    if (exportType === "qtiFormat")        endpoint = `api/export/${exportType}`;
    if (exportType === "qtiPackageFormat") endpoint = `api/lti/export_to_canvas?exportType=${exportType}`;
    if (exportType === "moodleXML")        endpoint = "api/lti/export_to_moodlexml";

    if (!isInterpretiveQuestionsClicked) scenarioQuestions  = [];
    if (!isMultipleChoiceClicked)        { mcqsQuestions = []; trueFalseQuestions = []; }
    if (!isNotesClicked)                 notesContent = [];
    if (!isOnlyRecallQAClicked)          fibQuestions = [];
    if (!isShortAnswerClicked)           mergedDescriptiveQuestion = [];

    const allQuestions = [
      ...mcqsQuestions, ...fibQuestions,
      ...trueFalseQuestions, ...mergedDescriptiveQuestion, ...scenarioQuestions,
    ];

    const exportToTxt = () => {
      let txtContent = "Eduvate\n====================\n\n";
      allQuestions.forEach((question, index) => {
        txtContent += `Q${index + 1}: ${question.Question}\n`;
        if (question.Options) {
          question.Options.forEach((option, optIndex) => { txtContent += `${optIndex + 1}): ${option}\n`; });
        }
        txtContent += `Answer: ${question.Answer}\n\n`;
      });
      txtContent += "Summary:\n" + notesContent + "\n";
      const blob = new Blob([txtContent], { type: "text/plain;charset=utf-8" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${cameFromHistoryPage ? individualTitleFromHistory : title}.txt`;
      document.body.appendChild(link); link.click(); document.body.removeChild(link);
      setLoading(false);
    };

    const exportToPDF = () => {
      const pdf = new jsPDF();
      const addHeader = () => {
        setLoading(true);
        const imgWidth = 50, imgHeight = 20;
        const xPosition = (pdf.internal.pageSize.width - imgWidth) / 2;
        const yPosition = 10;
        pdf.addImage(logoBase64, "PNG", xPosition, yPosition, imgWidth, imgHeight);
        const textYPosition = yPosition + imgHeight + 15;
        pdf.setFontSize(13); pdf.setTextColor(244, 132, 62);
        const maxWidth = pdf.internal.pageSize.width - 30;
        const splitTitle = pdf.splitTextToSize(`Title: ${cameFromHistoryPage ? individualTitleFromHistory : title}`, maxWidth);
        pdf.text(splitTitle, 15, textYPosition, { align: "left" });
        pdf.setFontSize(12);
        pdf.text(`Total Questions : ${allQuestions.length}`, pdf.internal.pageSize.width / 2 - 52, textYPosition + 15, { align: "right" });
        pdf.setTextColor(0, 0, 0);
        pdf.line(15, textYPosition + 20, pdf.internal.pageSize.width - 15, textYPosition + 20);
      };
      addHeader();
      let yOffset = 50 + 4 + 4 + 20 + 4;
      const xOffset = 15;
      allQuestions.forEach((question, index) => {
        pdf.setFontSize(12); pdf.setFont("helvetica", "bold");
        const splitQuestion = pdf.splitTextToSize(`Q${index + 1}. ${question.Question}`, 165);
        pdf.text(splitQuestion, xOffset, yOffset); yOffset += splitQuestion.length * 7;
        pdf.setFont("helvetica", "normal");
        if (question.Options) {
          question.Options.forEach((option, optIndex) => {
            const splitOption = pdf.splitTextToSize(`${optIndex + 1}): ${option}`, 155);
            pdf.text(splitOption, xOffset + 5, yOffset); yOffset += splitOption.length * 7;
          });
        }
        const splitAnswer = pdf.splitTextToSize(`Answer: ${question.Answer}`, 165);
        pdf.text(splitAnswer, xOffset + 5, yOffset); yOffset += splitAnswer.length * 7 + 10;
        if (yOffset > 220) { pdf.addPage(); yOffset = 30; }
      });
      pdf.setFontSize(14); pdf.text("Summary:", xOffset, yOffset); yOffset += 10;
      pdf.setFontSize(12);
      const splitNotes = pdf.splitTextToSize(notesContent, 165);
      pdf.text(splitNotes, xOffset, yOffset);
      const addFooter = () => {
        const pageCount = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) { pdf.setPage(i); }
      };
      addFooter();
      pdf.save(`${cameFromHistoryPage ? individualTitleFromHistory : title}.pdf`);
      setLoading(false); setOpen(false);
    };

    const exportToQTI = () => {
      let txtContent = "";
      allQuestions.forEach((question) => {
        txtContent += `${question.question}\n`;
        if (question.options) {
          const optionLetters = ["A", "B", "C", "D"];
          question.options.forEach((option, optIndex) => { txtContent += `${optionLetters[optIndex]}. ${option}\n`; });
        }
        txtContent += `ANSWER: ${question.answer}\n\n`;
      });
      const blob = new Blob([txtContent], { type: "application/xml" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${cameFromHistoryPage ? individualTitleFromHistory : title}.txt`;
      document.body.appendChild(link); link.click(); document.body.removeChild(link);
      URL.revokeObjectURL(blob); setLoading(false);
    };

    const exporttoQTIZIPV2 = async (zipFileData, packageName, data) => {
      try {
        const url = URL.createObjectURL(data);
        const a = document.createElement("a");
        a.href = url; a.download = packageName + ".zip"; a.click();
        URL.revokeObjectURL(url);
      } catch (err) { console.error("Error creating ZIP:", err.message); }
    };

    const exportToQTIFolder = async (zipFileData, packageName, data) => {
      try {
        saveAs(data, `${packageName}.zip`);
        const file = data.split("/");
        await axios.delete(process.env.REACT_APP_API_URL + "api/lti/unlink/" + file[file.length - 1]);
      } catch (err) { console.error("Error creating ZIP:", err.message); }
    };

    const exporttoMoodleXML = async (zipFileData, packageName, data) => {
      try {
        const url = URL.createObjectURL(data);
        const a = document.createElement("a");
        a.href = url; a.download = packageName + ".xml"; a.click();
        URL.revokeObjectURL(url);
      } catch (err) { console.error("Error creating ZIP:", err.message); }
    };

    try {
      const canvas = await axios.post(
        process.env.REACT_APP_API_URL + endpoint,
        {
          whQuestions: {
            response: {
              true_false_questions: trueFalseQuestions,
              mcqs_questions: mcqsQuestions,
              fib_questions: fibQuestions,
              wh_questions: mergedDescriptiveQuestion,
              scenario_based_questions: scenarioQuestions,
              notes: notesContent,
            },
          },
          docId:  ResponseQA?.doc_id || localStorage.getItem("doc_id") || individualDocIdFromHistory,
          title:  ResponseQA?.title  || localStorage.getItem("title")  || individualTitleFromHistory,
        },
        { withCredentials: true, responseType: ["qtiPackageFormat", "qtizipv2", "moodleXML"].includes(exportType) ? "blob" : "json" }
      );

      if (canvas.status === 200) {
        setLoading(false);
        const { data, config } = canvas;

        if (exportType === "qti")              { commonSuccessToastMessage("Quizzes created successfully."); setOpen(false); return; }
        if (exportType === "qtiPackageFormat") { exportToQTIFolder(config.data, title, data); commonSuccessToastMessage("Common Cartridge successfully exported."); setOpen(false); return; }
        if (exportType === "doc") {
          const link = document.createElement("a");
          const docContent = data?.data?.content || data?.content || "";
          if (!docContent) { console.error("Document content is undefined or empty."); return; }
          const formatContent = docContent.replace(/\r\n\n/g, "\n");
          const blob = new Blob(["\ufeff", formatContent], { type: "application/msword" });
          const url = URL.createObjectURL(blob);
          link.setAttribute("download", `${title}.doc`); link.setAttribute("href", url);
          document.body.appendChild(link); link.click(); document.body.removeChild(link);
          URL.revokeObjectURL(blob);
        }
        if (exportType === "pdf")  { exportToPDF(); commonSuccessToastMessage("Questions are successfully exported to PDF format."); }
        if (exportType === "txt")  { exportToTxt(); commonSuccessToastMessage("Questions are successfully exported to text format."); }
        if (exportType === "qtizipv2") { exporttoQTIZIPV2(config.data, title, data); setOpen(false); commonSuccessToastMessage("Questions are successfully exported to QTIv2.1.zip format."); return; }
        if (exportType === "qtiFormat") { exportToQTI(); commonSuccessToastMessage("Questions are successfully exported to .qti format."); }
        if (exportType === "moodleXML") { exporttoMoodleXML(config.data, title, data); setOpen(false); commonSuccessToastMessage("Questions are successfully exported to MoodleXML.zip format."); }

        setOpen(false); setLoading(false);
      }
    } catch (error) {
      setOpen(false); setLoading(false);
      commonErrorToastMessage("Error while exporting the questions.");
      console.error("Error while exporting:", error);
    } finally {
      if (exportType === "newQuizzes") { commonSuccessToastMessage("New Quizzes created successfully."); setOpen(false); setLoading(false); return; }
      setOpen(false); setLoading(false);
    }
  };

  return (
  <>
      <AppNavigation />
      <StepProgress activeStep={activeStep} />
    <div className={`${isCanvas ? " h-[75vh]" : " h-[75vh]"}`}>
      {/* Top-level container */}
      <div className={`flex bg-white ${isCanvas ? " h-[75vh]" : " h-[79vh]"}`}>
        {/* Left section - Question Container */}
        <div
          className={`w-full p-4 rounded-2xl question-container ${
            isCanvas ? " h-[75vh]" : " h-[79vh]"
          }`}
        >
          <>
                {/* Question Type Tabs */}
                <div className="question-type ">
                   <div className="flex place-content-around w-[90%]">
              {/* Rendering tabs with labels and total question counts */}
              {tabData.map((tab) => (
                <div>
                  <div
                    key={tab.id}
                    onClick={() => handleTabClick(tab.id)}
                    className={`cursor-pointer px-8 py-2  border border-transparent  font-medium ${
                      activeTab === tab.id
                        ? "border-b-2  border-b-[#0c3f5a] "
                        : "text-[#153fc6] hover:border-gray-300"
                    } transition duration-300 ease-in-out  ${
                      tab.id !== "first" ? "text-[#5E626A]" : "text-[#153fc6]"
                    } `}
                  >
                    {tab.label}
                    {tab.label === "Summary"
                      ? isCanvas
                        ? ""
                        : // <span className="beta-ribbon left-[82%] md:lg:left-[91%] lg:left-[71%]">
                          //   BETA
                          // </span>
                          ""
                      : ""}
                    {tab.label !== "Summary" ? (
                      <>
                        <span
                          className={`w-6 h-6 place-content-center px-3 pt-[2px] pb-[2px] text-sm text-center rounded-full ml-4 items-center justify-center ${
                            tab.id === "first"
                              ? " bg-[#0c3f5a] text-white"
                              : "bg-[#1462b0] text-white"
                          }`}
                        >
                          {tab.total}
                        </span>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ))}
                  </div>
                   <hr className="my-[10px] mr-20 ml-20" />
                </div>
                <div className="flex justify-center">
                  {/* {flex flex-row-reverse} */}
                   {/* Pass the activeStep value to the StepProgress component */}
                  <div className="w-[175vh]">
                  {/* Main content area for displaying questions and answers */}
                  <div className={`${isCanvas ? "h-[65vh]" : "h-[55vh]"} pb-2 `}>
            {/* Conditionally rendering content based on the active tab */}
            {/* Section for rendering question ideas */}
            {activeTab === "first" && (
              <div
                className={`border-t-[1px] border-b-[1px] animate-fade-slide-down p-5 mx-auto my-area custom-scrollbar overflow-x-hidden overflow-y-auto   ${
                  isCanvas ? "h-[65vh]" : "h-[55vh]"
                }`}
              >
                {totalQuestionNumber !== 0 ? (
                  <>
                    {mergedObjectiveQuestion.length &&
                      mergedObjectiveQuestion.map((q, i) => (
                        <div key={i}>
                          {/* TODO : DO the same for others */}
                          {/* Rendering MCQ questions */}
                          {q.category === "mcq" && (
                            <div
                              className={`${
                                isMultipleChoiceClicked ? "" : "hidden"
                              }`}
                            >
                              <McqQuestionsRenderer
                                generatedQuestionsFromSubmitContent={
                                  generatedQuestionsFromSubmitContent
                                }
                                setTotalQuestionNumber={setTotalQuestionNumber}
                                totalQuestionNumber={totalQuestionNumber}
                                activeStep={activeStep} // Pass other props here
                                handleMcqQuestionsEdit={handleMcqQuestionsEdit}
                                handleMcqQuestionDelete={
                                  handleMcqQuestionDelete
                                }
                                handleMcqQuestionChange={
                                  handleMcqQuestionChange
                                }
                                handleOptionEdit={handleOptionEdit}
                                handleOptionChange={handleOptionChange}
                                handleOptionBlur={handleOptionBlur}
                                editingOptionIndices={editingOptionIndices}
                                mcqsQuestions={mcqsQuestions}
                                question={q}
                                index={i}
                              />
                            </div>
                          )}

                          {/* Rendering FIB (Recall) questions */}
                          {q.category === "fib" && (
                            <div
                              className={`${
                                isOnlyRecallQAClicked ? "" : "hidden"
                              }`}
                            >
                              <FibQuestionsRenderer
                                generatedQuestionsFromSubmitContent={
                                  generatedQuestionsFromSubmitContent
                                }
                                setTotalQuestionNumber={setTotalQuestionNumber}
                                totalQuestionNumber={
                                  totalQuestionNumber + mcqsQuestions.length
                                }
                                activeStep={activeStep} // Pass other props here
                                handleFibQuestionChange={
                                  handleFibQuestionChange
                                }
                                handleFibAnswerChange={handleFibAnswerChange}
                                handleFibQuestionsEdit={handleFibQuestionsEdit}
                                handleFibAnswersEdit={handleFibAnswersEdit}
                                handleFibQuestionDelete={
                                  handleFibQuestionDelete
                                }
                                fibQuestions={fibQuestions}
                                question={q}
                                index={i}
                              />
                            </div>
                          )}

                          {/* Rendering True or False Questions */}
                          {q.category === "truefalse" && (
                            <div
                              className={`${
                                isMultipleChoiceClicked ? "" : "hidden"
                              }`}
                            >
                              <TrueOrFalseQuestionsRenderer
                                generatedQuestionsFromSubmitContent={
                                  generatedQuestionsFromSubmitContent
                                }
                                setTotalQuestionNumber={setTotalQuestionNumber}
                                totalQuestionNumber={totalQuestionNumber}
                                activeStep={activeStep} // Pass other props here
                                handleTrueOrFalseQuestionsEdit={
                                  handleTrueOrFalseQuestionsEdit
                                }
                                handleTrueOrFalseQuestionDelete={
                                  handleTrueOrFalseQuestionDelete
                                }
                                handleTrueOrFalseQuestionChange={
                                  handleTrueOrFalseQuestionChange
                                }
                                trueFalseQuestions={trueFalseQuestions}
                                question={q}
                                index={i}
                              />
                            </div>
                          )}
                        </div>
                      ))}
                  </>
                ) : (
                  <div
                    className={`flex flex-col justify-center items-center align-middle  ${
                      isCanvas ? "h-[65vh]" : "h-[48vh]"
                    }`}
                  >
                    {/*
                     */}
                  </div>
                )}
              </div>
            )}
            {/* Section for rendering "Wh" questions (which is the combination of Short and Descriptive Questions) */}
            {activeTab === "second" && (
              <div
                className={`border-t-[1px] border-b-[1px] animate-fade-slide-down p-5   mx-auto my-area custom-scrollbar overflow-x-hidden overflow-y-auto ${
                  isCanvas ? "h-[65vh]" : "h-[55vh]"
                }`}
              >
                {/* Rendering "Wh" questions with editing capabilities */}

                <div className={`${isShortAnswerClicked ? "" : "hidden"}`}>
                  {mergedDescriptiveQuestion.length !== 0 ? (
                    <WhQuestionsRenderer
                      generatedQuestionsFromSubmitContent={
                        generatedQuestionsFromSubmitContent
                      }
                      totalQuestionNumber={totalQuestionNumber}
                      setTotalQuestionNumber={setTotalQuestionNumber}
                      activeStep={activeStep}
                      handleShortWhQuestionChange={handleShortWhQuestionChange}
                      handleShortWhAnswerChange={handleShortWhAnswerChange}
                      handleShortWhQuestionsEdit={handleShortWhQuestionsEdit}
                      handleShortWhAnswersEdit={handleShortWhAnswersEdit}
                      handleShortWhQuestionDelete={handleShortWhQuestionDelete}
                      questions={whQuestions}
                    />
                  ) : (
                    // <div
                    //   className={`flex flex-col justify-center items-center align-middle  ${
                    //     isCanvas ? "h-[65vh]" : "h-[48vh]"
                    //   }`}
                    // >
                    //   <div className=" w-full  h-[81vh] m-auto flex flex-col justify-center align-middle items-center place-content-center  px-6 pt-4 rounded-2xl mx-5">
                    //     <div className=" border rounded-xl p-5 shadow-xl hover:shadow-2xl flex flex-col justify-center align-middle items-center place-content-center w-1/2">
                    //       {/* <img src={alertImage} alt="" className="w-1/5 " /> */}

                    //       <i className="fa-solid fa-triangle-exclamation text-red-400 fa-3x"></i>

                    //       <p className="mt-5 text-center font-semibold text-red-400">
                    //         You have deleted all the Wh Questions.
                    //       </p>
                    //     </div>
                    //   </div>
                    // </div>
                    ""
                  )}
                </div>
              </div>
            )}
            {activeTab === "third" && (
              <div
                className={`border-t-[1px] border-b-[1px] animate-fade-slide-down p-5   mx-auto my-area   custom-scrollbar overflow-x-hidden overflow-y-auto ${
                  isCanvas ? "h-[65vh]" : "h-[55vh]"
                }`}
              >
                {/* Rendering Interpretive Questions with editing capabilities */}
                <div
                  className={`${
                    isInterpretiveQuestionsClicked ? "" : "hidden"
                  }`}
                >
                  {generatedQuestionsFromSubmitContent?.questions?.questionset?.scenario_based_questions || generatedQuestionsFromSubmitContent?.response?.questions?.questionset?.scenario_based_questions || generatedQuestionsFromSubmitContent?.scenario_based_questions?.questions  || cameFromHistoryPage ? (
                    <InterpretiveQuestionsRenderer
                      generatedQuestionsFromSubmitContent={
                        generatedQuestionsFromSubmitContent
                      }
                      totalQuestionNumber={totalQuestionNumber}
                      setTotalQuestionNumber={setTotalQuestionNumber}
                      activeStep={activeStep}
                      handleScenarioQuestionChange={
                        handleScenarioQuestionChange
                      }
                      handleScenarioAnswerChange={
                        handleScenarioAnswerChange
                      }
                      handlescenarioQuestionsEdit={
                        handlescenarioQuestionsEdit
                      }
                      handleScenarioAnswersEdit={
                        handleScenarioAnswersEdit
                      }
                      handleScenarioQuestionDelete={
                        handleScenarioQuestionDelete
                      }
                      questions={scenarioQuestions}
                    />
                  ) : (
                    // <div
                    //   className={`flex flex-col justify-center items-center align-middle  ${
                    //     isCanvas ? "h-[65vh]" : "h-[48vh]"
                    //   }`}
                    // >
                    //   <div className=" w-full  h-[81vh] m-auto flex flex-col justify-center align-middle items-center place-content-center  px-6 pt-4 rounded-2xl mx-5">
                    //     <div className=" border rounded-xl p-5 shadow-xl hover:shadow-2xl flex flex-col justify-center align-middle items-center place-content-center w-1/2">
                    //       {/* <img src={alertImage} alt="" className="w-1/5 " /> */}
                    //       <i className="fa-solid fa-circle-exclamation text-red-400 fa-3x"></i>

                    //       <p className="mt-5 text-center font-semibold text-red-400">
                    //         Interpretive questions are generated for content
                    //         with over 1000 words.
                    //       </p>
                    //     </div>
                    //   </div>
                    // </div>
                    <>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* Section for rendering notes */}
            {activeTab === "fourth" && (
              <div
                className={`border-t-[1px] border-b-[1px] animate-fade-slide-down p-5 mx-auto  ${
                  isCanvas ? "h-[65vh]" : "h-[55vh]"
                } `}
              >
                <textarea
                  className={`w-full h-full  p-2 hover:border-[#f4833d] border-2 border-white hover:border-dotted rounded outline-none resize-none custom-scrollbar overflow-none ${
                    isNotesClicked ? "" : "hidden"
                  }`}
                  value={notesContent}
                  onChange={(e) => setNotesContent(e.target.value)}
                />
              </div>
            )}
                  </div>
                  </div>
                </div>        
          </>
          {/* Bottom section with a button to save the questions */}
          <div className="pt-[10px] h-9">
            <div className=" flex 50vh">
                <p className="text-[#777e8d] font-semibold text-xs px-2 mt-[10px]">
                To edit a question or answer, just click on it.
              </p>
                <div className="flex place-content-end gap-5 w-[160vh]">
                <div className="flex gap-5">
                <div className="flex gap-5">
                  <div>
                    <Tooltip
                      title="Export Question"
                      arrow
                      placement="top"
                      TransitionComponent={Zoom}
                      TransitionProps={{ timeout: 300 }}
                    >
                      <button
                        onClick={() => setOpen(true)}
                        className="rounded hover:opacity-80 bg-[#c6530c] text-white text-xs px-4 py-2 mt-1 transition duration-300 ease-in-out"
                      >
                        Export Questions
                      </button>
                    </Tooltip>
                  </div>

                  <div>
                    <Tooltip
                      title="Save your questions"
                      arrow
                      placement="top"
                      TransitionComponent={Zoom}
                      TransitionProps={{ timeout: 300 }}
                    >
                      <button
                        // disabled={isSampleButtonClicked && Version === 'Free'}
                        onClick={handleQuestionsSaveToDB}
                        className={`rounded hover:opacity-80 bg-[#c6530c] text-white text-xs px-4 py-2 mt-1 transition duration-300 ease-in-out ${isSampleButtonClicked && Version === 'Free' ? "opacity-50 cursor-not-allowed" : ""}`}
                      >
                        Save
                      </button>
                    </Tooltip>
                  </div>
                </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
        className=""
        maxWidth="sm"
        fullWidth={true}
        open={open}
        disableBackdropClick={true}
      >
        <DialogTitle className="text-[10px] ">
          <span>Export Questions : </span>
          <Tooltip
            title="Close"
            arrow
            placement="top"
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 300 }}
          >
            <button
              // className="text-[#6c757d] bg-transparent text-lg float-right"
              className="text-[#6c757d] text-lg hover:bg-[#edeeef] px-2 float-right rounded-full "
              onClick={() => setOpen(false)}
            >
              <i className="fa-solid fa-xmark"></i>{" "}
            </button>
          </Tooltip>
        </DialogTitle>

        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box>
            <Stack
              direction="row"
              gap={4}
              className="mb-2 flex gap-8 align-middle place-content-evenly justify-center"
            >
              {isCanvas ? (
                <div className="flex gap-8 align-middle place-content-center justify-center ">
                  <Tooltip
                    title="Export to Canvas"
                    arrow
                    placement="top"
                    TransitionComponent={Zoom}
                    TransitionProps={{ timeout: 300 }}
                  >
                    <Button 
                    onClick={(e)=>exportQuestions(e ,'qti')}
                    // disabled={isSampleButtonClicked && Version === 'Free'}
                    className={`bg-pink-200 ${isSampleButtonClicked && Version === 'Free' ? "opacity-50 cursor-not-allowed" : ""}`} >
                      <img
                        src={CanvasLogo}
                        alt="Canvas"
                        className="w-16 h-16 rounded-lg border shadow-xl"
                      />
                    </Button>
                  </Tooltip>

                  {/* Export to New Quizzes*/}
                  <Tooltip
                    title="Export to NewQuizzes1"
                    arrow
                    placement="top"
                    TransitionComponent={Zoom}
                    TransitionProps={{ timeout: 300 }}
                  >
                    <Button 
                    onClick={(e)=>exportQuestions(e ,'newQuizzes')}
                    style={{ padding: '2px 4px' }}
                    // disabled={isSampleButtonClicked && Version === 'Free'}
                    className={`bg-pink-200 ${isSampleButtonClicked && Version === 'Free' ? "opacity-50 cursor-not-allowed" : ""}`} >
                      <img
                        src={newQuizzeLog}
                        alt="New Quizzes"
                        className="w-16 h-16 rounded-lg border shadow-xl"
                      />
                    </Button>
                  </Tooltip>

                  {/* Export to QTI Format */}
                  <Tooltip
                    title="Export to QTI"
                    arrow
                    placement="top"
                    TransitionComponent={Zoom}
                    TransitionProps={{ timeout: 300 }}
                  >
                    <Button 
                    onClick={(e)=>exportQuestions(e ,'qtiFormat')}
                    style={{ padding: '2px 4px' }}
                    // disabled={isSampleButtonClicked && Version === 'Free'}
                    className={`bg-pink-200 ${isSampleButtonClicked && Version === 'Free' ? "opacity-50 cursor-not-allowed" : ""}`} >
                      <img
                        src={qtiLogo}
                        alt="QTI"
                        className="w-16 h-16 rounded-lg border shadow-xl py-1 qti-image"
                      />
                    </Button>
                  </Tooltip>
                </div>
              ) : null}
            </Stack>

            <Stack direction="row" gap={4}>
              <div className="flex gap-8">
                {/* Export to Word */}
                <Tooltip
                  title="Export to Word"
                  arrow
                  placement="top"
                  TransitionComponent={Zoom}
                  TransitionProps={{ timeout: 300 }}
                >
                  <Button 
                  onClick={(e)=>exportQuestions(e ,'doc')}
                  style={{ padding: '2px 4px' }}
                    // disabled={isSampleButtonClicked && Version === 'Free'}
                    className={`bg-pink-200 ${isSampleButtonClicked && Version === 'Free' ? "opacity-50 cursor-not-allowed" : ""}`} >
                    <img
                      src={wordLogo}
                      alt="Word"
                      className="w-16 h-16 rounded-lg border shadow-xl py-1"
                    />
                  </Button>
                  <p className="text-[10px] mt-[8px] font-medium">Export in word <br/> <p className="flex justify-center">format</p></p>
                </Tooltip>

                {/* Export to PDF */}
                  <Tooltip
                    title="Export to PDF"
                    arrow
                    placement="top"
                    TransitionComponent={Zoom}
                    TransitionProps={{ timeout: 300 }}
                    >
                    <Button
                    onClick={(e)=>exportQuestions(e ,'pdf')}
                    style={{ padding: '2px 4px' }}
                    // disabled={isSampleButtonClicked && Version === 'Free'}
                    className={`bg-pink-200 ${isSampleButtonClicked && Version === 'Free' ? "opacity-50 cursor-not-allowed" : ""}`} >
                    <img
                      src={pdfLogo}
                      alt="PDF"
                      className="w-16 h-16 rounded-lg py-1 border shadow-xl"
                    />
                    </Button>
                  <p className="text-[10px] mt-[8px] font-medium">Export in PDF <br/> <p className="flex justify-center">format</p></p>
                  </Tooltip>
              </div>

              <div className="flex gap-8">
                {/* Export to Text */}
                <Tooltip
                  title="Export to Text"
                  arrow
                  placement="top"
                  TransitionComponent={Zoom}
                  TransitionProps={{ timeout: 300 }}
                >
                  <Button
                  onClick={(e)=>exportQuestions(e ,'txt')}
                   style={{ padding: '2px 4px' }}>
                    <img
                      src={textLogo}
                      alt="Text"
                      className="w-16 h-16 rounded-lg border shadow-xl"
                    />
                  </Button>
                  <p className="text-[10px] mt-[8px] font-medium">Export in TXT <br/> <p className="flex justify-center">format</p></p>
                </Tooltip>

                {/* Export to QTI format */}
                {isCanvas ? (
                  ""
                ) : (
                  <Tooltip
              title="Export to QTIv2.1.zip"
              arrow
              placement="top"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 300 }}
            >
              <Button onClick={(e) => exportQuestions(e, 'qtizipv2')} 
                // disabled={isSampleButtonClicked && Version === 'Free'}
               className={`bg-pink-200 ${isSampleButtonClicked && Version === 'Free' ? "opacity-50 cursor-not-allowed" : ""}`} >
                <img src={QTIVersion2} alt="QTI.zip" className="w-16 h-16 rounded-lg border shadow-xl py-1" />
              </Button>
               <p className="text-[10px] mt-[8px] font-medium"> Export for Instructure <br/>Canvas (QTI format)</p>
            </Tooltip>
                )}
  
              {isCanvas ? (
                ""
              ) : (
                <Tooltip
              title="Export to MoodleXML.zip"
              arrow
              placement="top"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 300 }}
            >
              <Button onClick={(e) => exportQuestions(e, 'moodleXML')} 
              // disabled={isSampleButtonClicked && Version === 'Free'}
              className={`bg-pink-200 ${isSampleButtonClicked && Version === 'Free' ? "opacity-50 cursor-not-allowed" : ""}`} >
                <img src={Moodleimage} alt="MoodleXML.zip" className="w-16 h-16 rounded-lg border shadow-xl py-1" />
              </Button>
               <p className="text-[10px] mt-[8px] font-medium"> Export in Moodle's<br/> <p className="flex justify-center">MoodleXML format</p></p>
            </Tooltip>
              )}  
              </div>
            </Stack>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Render the Share Your Feedback Modal component */}
      {isRateYourQuestionModalOpen && (
        <RateYourQuestionsModal
          open={handleRateYourQuestions}
          onClose={() => setIsRateYourQuestionModalOpen(false)}
        />
      )}
      {loading && <LoadingOverlay />}

       {/* Render the Go Premium Modal component */}
              <QuillionzProUpgradeModal
                isOpen={showManageSubscription}
                onClose={() => setShowManageSubscription(false)}
              />
      
    </div>
    </>
  );
};

export default Question;
